import React, { useState } from "react";
import { Link, useLocation, useNavigate, Outlet } from "react-router-dom";
import { LogOut, Menu, X, Home } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function DashboardLayout({ nav, title }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex">
      {/* Sidebar */}
      <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 viriks-navy text-white flex flex-col transition-transform duration-300 ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`} data-testid="dashboard-sidebar">
        <div className="h-16 flex items-center gap-2 px-6 border-b border-white/10">
          <div className="inline-flex bg-white rounded-md p-1.5">
            <img src="/viriks-logo.jpg" alt="VIRIKS" className="h-6 w-auto" />
          </div>
        </div>
        <div className="px-4 py-3 text-xs uppercase tracking-wider text-white/40 font-semibold">{title}</div>
        <nav className="flex-1 overflow-y-auto px-3 space-y-1 no-scrollbar">
          {nav.map((item) => {
            const active = location.pathname === item.to;
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${active ? "viriks-amber text-white" : "text-white/70 hover:bg-white/10 hover:text-white"}`}
              >
                <Icon size={18} /> {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <Link to="/" className="flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-white/70 hover:bg-white/10">
            <Home size={18} /> Back to Site
          </Link>
          <button onClick={() => { logout(); navigate("/"); }} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm text-white/70 hover:bg-white/10" data-testid="sidebar-logout">
            <LogOut size={18} /> Logout
          </button>
        </div>
      </aside>

      {open && <div className="fixed inset-0 bg-black/40 z-30 lg:hidden" onClick={() => setOpen(false)} />}

      {/* Main */}
      <div className="flex-1 min-w-0">
        <header className="h-16 bg-white border-b border-border flex items-center justify-between px-4 lg:px-8 sticky top-0 z-20">
          <button className="lg:hidden" onClick={() => setOpen(true)} data-testid="sidebar-toggle"><Menu size={22} /></button>
          <div className="flex-1" />
          <div className="flex items-center gap-3">
            <span className="text-sm font-medium text-navy hidden sm:block">{user?.name}</span>
            <div className="h-9 w-9 rounded-full viriks-navy text-amber flex items-center justify-center font-heading font-bold">
              {user?.name?.[0]?.toUpperCase()}
            </div>
          </div>
        </header>
        <main className="p-4 lg:p-8 max-w-7xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
